export const conversionStateOptions = [
  { label: "开启", value: "ENABLED" },
  { label: "不显示", value: "HIDDEN" },
  { label: "已移除", value: "REMOVED" },
  { label: "未知", value: "UNKNOWN" },
  { label: "未指定", value: "UNSPECIFIED" },
];

export const conversionTypeOptions = [
  { label: "首次打开", value: "FIRST_OPEN" },
  { label: "应用内购买", value: "IN_APP_PURCHASE" },
  { label: "自定义事件", value: "CUSTOM" },
  { label: "下载", value: "GOOGLE_PLAY_DOWNLOAD" },
  { label: "其他", value: "OTHER" },
];

export const statusOptions = [
  { label: "不限", value: null },
  { label: "显示", value: 1 },
  { label: "隐藏", value: 0 },
];
export const clickTimeRangeOptions = [
  { label: "1周", value: "1week" },
  { label: "2周", value: "2week" },
  { label: "3周", value: "3week" },
  { label: "4周", value: "4week" },
  { label: "30天", value: "30day" },
  { label: "45天", value: "45day" },
  { label: "60天", value: "60day" },
  { label: "90天", value: "90day" },
];
